module.exports = __webpack_public_path__ + "static/media/quality-control.2aef5f23.jpg";